import { Link } from 'react-router-dom';
import type { Film } from '@/types/content';

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex flex-col bg-background-100 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 海报`}
          title={`${film.title} 剧情介绍与演员资料`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-500/90 text-background-50 backdrop-blur">
          {film.type === 'movie' ? '电影' : '电视剧'}
        </span>
        {film.rating > 0 && (
          <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-md text-[11px] font-semibold bg-accent-500 text-primary-950">
            <i className="ri-star-fill text-[10px]" />
            {film.rating.toFixed(1)}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-700 transition-colors">
          {film.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{film.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400" />
          <span>{film.region}</span>
          <span className="w-1 h-1 rounded-full bg-background-400" />
          <span>{film.genres.slice(0, 2).join(' · ')}</span>
        </div>
        <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{film.synopsis}</p>
      </div>
    </Link>
  );
}